import {defineField} from 'sanity'
import {dotcomDocument} from './dotcom.document'

export default defineField({
  title: 'silversea.com Ship',
  name: 'dotcomShip',
  ...dotcomDocument('ship'),
  weak: false,
})
